import { useApiQuery, useApiMutation } from "../services/react-query.js";

export const useGetAllTickets = ({ eventId, page }) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["newTickets", eventId, page],
    },
    fetchOptions: {
      url: "/new-tickets",
      method: "GET",
      params: { eventId, page },
    },
  });
};

export const useGetTicketById = (id) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["newTicket", id],
      enabled: !!id,
    },
    fetchOptions: {
      url: `/new-tickets/${id}`,
      method: "GET",
    },
  });
};

export const useCreateTicket = () => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: ["newTickets"],
    },
    fetchOptions: {
      url: "/new-tickets",
      method: "POST",
    },
    invalidateQueryKeys: [["newTickets"]],
    successMessage: {
      title: "Ticket was created successfully",
    },
  });
};

export const useUpdateTicket = ({ id, data }) => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: "useUpdateTicket",
    },
    fetchOptions: {
      url: `/new-tickets/${id}`,
      method: "PATCH",
      body: { data },
    },
    invalidateQueryKeys: [["newTicket", id], ["newTickets"]],
    successMessage: { title: "Ticket has been updated successfully." },
  });
};

export const useDeleteTicket = ({ id }) => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: "useDeleteTicket",
      enabled: !!id,
    },
    fetchOptions: {
      url: `/new-tickets/${id}`,
      method: "DELETE",
    },
    invalidateQueryKeys: [["newTickets"]],
    successMessage: { title: "Ticket has been deleted successfully." },
  });
};
